var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['modal-window', `modal-window-${_vm.type}`]},[_c('div',{staticClass:"modal-window-bg",on:{"click":_vm.toggleModal}}),_vm._v(" "),_c('div',{staticClass:"modal-window-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }